import CaseInfo from './CaseInfo.js';
export default CaseInfo;
//# sourceMappingURL=index.js.map